// shades/shell.jsx — full-takeover Shades surface.
//
// Replaces the centered AShadesModal. Wraps the existing AShadesModal
// body inside TakeoverShell. Blinds / sheers / louvres each render via
// AShadesModal's own logic.

import { TakeoverShell, AShadesModal } from '../direction-a.jsx';

export function ShadesShell({ T, open, onClose, rooms, focusRoomId, viewport, update, louvreCommand, coverCommand }) {
  if (!open || !focusRoomId) return null;
  const room = rooms?.find((r) => r.id === focusRoomId);
  if (!room) return null;
  return (
    <TakeoverShell T={T} viewport={viewport}
      eyebrow="Shades" title={room.name} onClose={onClose}>
      <AShadesModal T={T} room={room} update={update}
        louvreCommand={louvreCommand} coverCommand={coverCommand}/>
    </TakeoverShell>
  );
}
